// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormHeader_wrapper__1LWWj","back":"FormHeader_back__2Sb0o","title":"FormHeader_title__2gMPT","gold":"FormHeader_gold__lC-Nq"};